module.exports = "https://cdn.realtymogul.com/static/media/multifamily_hero.b27100c3.jpg";